import {
  defaultTheme,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import {
  AccountBinInputPageCvcFlatFields,
  AccountBinInputPageFlatFields,
} from 'src/app/RegisterAccount/RegisterAccount'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgUpdate from 'src/components/Svgs/SvgUpdate'
import { IssuerSchemaFilterFields } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { IssuerIntegratorListModel } from 'src/models/issuerIntegrator.models'
import { css } from 'styled-components'

interface RegisterAccountCardInfoProps {
  className?: string
  accountBinInputPageFlatFields: AccountBinInputPageFlatFields
  accountBinInputPageCvcFlatFields: AccountBinInputPageCvcFlatFields
  selectedIssuer?: IssuerIntegratorListModel
  returnToCardInformation: () => void
}

const RegisterAccountCardInfo: React.FC<RegisterAccountCardInfoProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const cvcRequired =
    props.selectedIssuer?.schema !== undefined &&
    props.selectedIssuer.schema.filter(
      (field) => field.name === IssuerSchemaFilterFields.cvc,
    ).length > 0

  return (
    <div
      className={props.className}
      css={css`
        margin-top: 10px;
        padding: 40px;
        border: 1px solid ${defaultTheme.colors.cta_dark};
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
      `}
    >
      <div
        css={css`
          display: flex;
          align-self: center;
          border-radius: 3px;
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
          padding: ${!props.selectedIssuer?.url && '15px'};
        `}
      >
        {props.selectedIssuer?.url === undefined ? (
          <span
            id={props.selectedIssuer?.name + ' Img'}
            css={css`
              width: 80px;
              padding: 12px 8px;
              ${getFontCss(
                12,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
            `}
          >
            {props.selectedIssuer?.name}
          </span>
        ) : (
          <img
            id={props.selectedIssuer.name + ' Img'}
            css={css`
              width: 80px;
              padding: 12px 8px;
            `}
            src={props.selectedIssuer.url}
            alt={props.selectedIssuer.name}
          />
        )}
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 160px;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              20,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-bottom: 8px;
          `}
        >
          {props.selectedIssuer?.name}
        </span>
        <span>{props.accountBinInputPageFlatFields.cardNumber}</span>
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
            margin-bottom: 8px;
          `}
        >
          {translate('Expiration')}
        </span>
        <span>{props.accountBinInputPageFlatFields.expirationDate}</span>
      </div>
      {cvcRequired && (
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          <span
            css={css`
              ${getFontCss(
                14,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )};
              margin-bottom: 8px;
            `}
          >
            {translate('CVC')}
          </span>
          <span>{props.accountBinInputPageCvcFlatFields.cvc}</span>
        </div>
      )}
      <div
        css={css`
          top: -4px;
          position: relative;
        `}
      >
        <HoverableLink
          css={css`
            display: flex;
            align-items: center;
          `}
          onClick={props.returnToCardInformation}
          ariaLabelSource={'Update'}
          testId="updateCardInfo"
        >
          <SvgUpdate
            css={css`
              transform: scale(calc(14 / 24));
            `}
          />
          {translate('Update')}
        </HoverableLink>
      </div>
    </div>
  )
}

export default RegisterAccountCardInfo
